

export const AUTH_TOKEN_KEY = 'jwtToken'


// WEBPACK FOOTER //
// ./src/constants/base.js